export function getDateRanges(id, referenceDate = new Date()) {
  const startOfDay = (date) => (new Date(date.getFullYear(), date.getMonth(), date.getDate()));
  const endOfDay = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);

  const getStartOfWeek = (date) => {
    const day = date.getDay(); // 0 (Sunday) to 6 (Saturday)
    const diff = date.getDate() - day + (day === 0 ? -6 : 1); // Adjust when Sunday
    return new Date(date.getFullYear(), date.getMonth(), diff);
  };

  const getQuarter = (month) => Math.floor(month / 3);
  const getStartOfQuarter = (date) => new Date(date.getFullYear(), getQuarter(date.getMonth()) * 3, 1);
  const getEndOfQuarter = (date) => {
    const quarter = getQuarter(date.getMonth());
    const endMonth = (quarter + 1) * 3 - 1;
    return new Date(date.getFullYear(), endMonth + 1, 0, 23, 59, 59, 999);
  };

    function getLastDayOfCurrentYear() {
        const today = new Date();
        return new Date(today.getFullYear(), 11, 31); // December is month 11 (0-based)
    }


  const today = startOfDay(referenceDate);
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const startOfWeek = getStartOfWeek(today)
  const startOfLastWeek = new Date(startOfWeek);
  startOfLastWeek.setDate(startOfLastWeek.getDate() - 7);

  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const startOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0, 23, 59, 59, 999);

  const startOfQuarter = getStartOfQuarter(today);
  const endOfQuarter = getEndOfQuarter(today);

  const prevQuarterDate = new Date(startOfQuarter);
  prevQuarterDate.setMonth(prevQuarterDate.getMonth() - 3);
  const startOfPrevQuarter = getStartOfQuarter(prevQuarterDate);
  const endOfPrevQuarter = getEndOfQuarter(prevQuarterDate);

  const startOfYear = new Date(today.getFullYear(), 0, 1);
  const startOfLastYear = new Date(today.getFullYear() - 1, 0, 1);
  const endOfLastYear = new Date(today.getFullYear() - 1, 11, 31, 23, 59, 59, 999);

  function getLastDayOfCurrentMonth() {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth() + 1, 0); // Day 0 of next month = last day of current
}

  function formatDateToDDMMYYYY(date) {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

  if(id === 0){
    return {
        start: formatDateToDDMMYYYY(startOfDay(yesterday)),
        end: formatDateToDDMMYYYY(endOfDay(yesterday))
    }
  }
  if(id === 1){
    let auxDate = new Date(today)
    auxDate.setDate(auxDate.getDate() - 7)
    return {
        start: formatDateToDDMMYYYY(startOfDay(auxDate)),
        end: formatDateToDDMMYYYY(endOfDay(today))
    }
  }
  if(id === 2){
    let auxDate = new Date(endOfDay(startOfWeek))
    auxDate.setDate(auxDate.getDate() + 6)
    return {
        start: formatDateToDDMMYYYY(startOfDay(startOfWeek)),
        end: formatDateToDDMMYYYY(auxDate)
    }
  }
  if(id === 3){
    return {
        start: formatDateToDDMMYYYY(startOfDay(startOfLastWeek)),
        end: formatDateToDDMMYYYY(endOfDay(new Date(startOfLastWeek.getFullYear(), startOfLastWeek.getMonth(), startOfLastWeek.getDate() + 6))),
    }
  }
  if(id === 4){
    return {
        start: formatDateToDDMMYYYY(startOfDay(startOfMonth)),
        end: formatDateToDDMMYYYY(endOfDay(getLastDayOfCurrentMonth())),
    }
  }
  if(id === 5){
    return {
        start: formatDateToDDMMYYYY(startOfDay(startOfLastMonth)),
        end: formatDateToDDMMYYYY(endOfDay(endOfLastMonth)),
    }
  }
  if(id === 6){
    return {
        start: formatDateToDDMMYYYY(startOfDay(startOfQuarter)),
        end: formatDateToDDMMYYYY(endOfDay(endOfQuarter)),
    }
  }
  if(id === 7){
    return {
        start: formatDateToDDMMYYYY(startOfDay(startOfPrevQuarter)),
        end: formatDateToDDMMYYYY(endOfDay(endOfPrevQuarter)),
    }
  }
  if(id === 8){
    return {
        start: formatDateToDDMMYYYY(startOfDay(startOfYear)),
        end: formatDateToDDMMYYYY(endOfDay(getLastDayOfCurrentYear())),
    }
  }
  if(id === 9){
    return {
        start: formatDateToDDMMYYYY(startOfDay(startOfLastYear)),
        end: formatDateToDDMMYYYY(endOfDay(endOfLastYear)),
    }
  }
  if(id === 10){
    return {
        start: formatDateToDDMMYYYY(startOfDay(startOfYear)),
        end: formatDateToDDMMYYYY(endOfDay(today)),
    }
  }
  if(id === 11){
    return {
        start: formatDateToDDMMYYYY(startOfDay(startOfMonth)),
        end: formatDateToDDMMYYYY(endOfDay(today)),
    }
  }
  if(id === 12){
    return {
        start: formatDateToDDMMYYYY(startOfDay(startOfWeek)),
        end: formatDateToDDMMYYYY(endOfDay(today)),
    }
  }
}